<div class="container row">
  <!-- Sección de preferencias -->
  <app-config-line
    [title]="'Preferencias del historial'"
    [titleLevel]="7"
    [withHr]="false"
    [sectionReturn]="configSections.VIEWS_PREFERENCES"
    [render]="!filterOptionsBy"
  >
  </app-config-line>

  <!-- Fecha de inicio -->
  <app-config-line
    [title]="'Fecha de inicio'"
    [description]="'Establece el día a partir del cual se mostrará la información en el historial del vehículo.'"
    [filterBy]="filterOptionsBy"
  >
    <input
      type="date"
      class="custom-input-date"
      [(ngModel)]="historialService.config.form.startDate"
    />
  </app-config-line>

  <!-- Hora de inicio -->
  <app-config-line
    [title]="'Hora de inicio'"
    [description]="'Define la hora exacta desde la que se comenzará a consultar la información del historial del vehículo.'"
    [filterBy]="filterOptionsBy"
  >
    <p-calendar
      [timeOnly]="true"
      [showIcon]="true"
      icon="pi pi-clock"
      [appendTo]="'body'"
      [showSeconds]="true"
      hourFormat="24"
      placeholder="HH:MM:SS"
      [(ngModel)]="historialService.config.form.startTime"
    ></p-calendar>
  </app-config-line>

  <!-- Fecha final -->
  <app-config-line
    [title]="'Fecha de finalización'"
    [description]="'Selecciona el último día que se incluirá en la consulta del historial del vehículo.'"
    [filterBy]="filterOptionsBy"
  >
    <input
      type="date"
      class="custom-input-date"
      [(ngModel)]="historialService.config.form.endDate"
    />
  </app-config-line>

  <!-- Hora final -->
  <app-config-line
    [title]="'Hora de finalización'"
    [description]="'Indica la hora límite hasta la cual se mostrará la información registrada en el historial del vehículo.'"
    [filterBy]="filterOptionsBy"
  >
    <p-calendar
      [timeOnly]="true"
      [showIcon]="true"
      icon="pi pi-clock"
      [appendTo]="'body'"
      [showSeconds]="true"
      hourFormat="24"
      placeholder="HH:MM:SS"
      [(ngModel)]="historialService.config.form.endTime"
    ></p-calendar>
  </app-config-line>
</div>
<app-user-history-drawer [filterOptionsBy]="filterOptionsBy"></app-user-history-drawer>
